import { render, staticRenderFns } from "./full_trend_works.vue?vue&type=template&id=34cbd77f&"
import script from "./full_trend_works.vue?vue&type=script&lang=js&"
export * from "./full_trend_works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports